import React, { useId, useState } from "react";
import VideoList from "../components/videos/VideoList";

function VideosTitleIcon() {
  const maskId = useId();
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <mask id={maskId} style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d="M5.09597 19C4.63564 19 4.2513 18.8458 3.94297 18.5375C3.63464 18.2292 3.48047 17.8448 3.48047 17.3845V6.6155C3.48047 6.15517 3.63464 5.77083 3.94297 5.4625C4.2513 5.15417 4.63564 5 5.09597 5H15.8652C16.3254 5 16.7096 5.15417 17.018 5.4625C17.3263 5.77083 17.4805 6.15517 17.4805 6.6155V11.2692L19.8227 8.927C19.9511 8.79867 20.0991 8.76658 20.267 8.83075C20.435 8.89492 20.519 9.018 20.519 9.2V14.8C20.519 14.982 20.435 15.1051 20.267 15.1692C20.0991 15.2334 19.9511 15.2013 19.8227 15.073L17.4805 12.7308V17.3845C17.4805 17.8448 17.3263 18.2292 17.018 18.5375C16.7096 18.8458 16.3254 19 15.8652 19H5.09597ZM5.09597 18H15.8652C16.0446 18 16.192 17.9423 16.3075 17.827C16.4228 17.7115 16.4805 17.564 16.4805 17.3845V6.6155C16.4805 6.436 16.4228 6.2885 16.3075 6.173C16.192 6.05767 16.0446 6 15.8652 6H5.09597C4.91647 6 4.76897 6.05767 4.65347 6.173C4.53814 6.2885 4.48047 6.436 4.48047 6.6155V17.3845C4.48047 17.564 4.53814 17.7115 4.65347 17.827C4.76897 17.9423 4.91647 18 5.09597 18Z"
          fill="#333333"
        />
      </g>
    </svg>
  );
}

export default function VideosPage() {
  const [uploadOpen, setUploadOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#F4F7FB] font-['Open_Sans']">
      {/* Header card */}
      <div className="pt-[32px] px-[32px]">
        <div className="w-full h-[89px] bg-[#FDFEFF] rounded-[8px] px-[24px] py-[16px] flex items-center justify-between">
          <div className="flex flex-col justify-between h-full">
            <div className="flex items-center gap-[8px] h-[31px]">
              <div className="text-[#333333] font-extrabold text-[20px] leading-[155%]">Videos</div>
              <VideosTitleIcon />
            </div>
            <div className="text-[#333333] font-light text-[14px] leading-[155%]">
              Upload and manage road inspection videos
            </div>
          </div>

          <button
            type="button"
            onClick={() => setUploadOpen(true)}
            className="w-[144px] h-[40px] bg-[#5937D6] rounded-[4px] flex items-center justify-center gap-[4px] px-[12px] py-[8px]"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.25 16.5V7.7895L8.625 10.4145L7.575 9.375L12 4.95L16.425 9.375L15.375 10.4145L12.75 7.7895V16.5H11.25ZM6 19.5C5.5875 19.5 5.2345 19.353 4.941 19.059C4.647 18.765 4.5 18.4125 4.5 18V15H6V18H18V15H19.5V18C19.5 18.4125 19.353 18.765 19.059 19.059C18.765 19.353 18.4125 19.5 18 19.5H6Z"
                fill="#FAFAFA"
              />
            </svg>
            <span className="text-[#FAFAFA] font-normal text-[14px] leading-[155%]">
              Upload Video
            </span>
          </button>
        </div>
      </div>

      {/* List */}
      <div className="pt-[16px] px-[32px]">
        <VideoList uploadOpen={uploadOpen} onCloseUpload={() => setUploadOpen(false)} />
      </div>
    </div>
  );
}